"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var serializr_1 = require("serializr");
var types_1 = require("./types");
var CommentEntity = /** @class */ (function () {
    function CommentEntity() {
    }
    tslib_1.__decorate([
        serializr_1.serializable(serializr_1.object(types_1.SocialText))
    ], CommentEntity.prototype, "text", void 0);
    return CommentEntity;
}());
var Comment = /** @class */ (function () {
    function Comment(comment) {
        this.commentId = comment.commentId;
        this.createdAt = comment.createdAt;
        this.createdBy = comment.createdBy;
        this.comment = comment.comment;
    }
    tslib_1.__decorate([
        serializr_1.serializable
    ], Comment.prototype, "commentId", void 0);
    tslib_1.__decorate([
        serializr_1.serializable(serializr_1.object(types_1.SocialIdentity))
    ], Comment.prototype, "createdBy", void 0);
    tslib_1.__decorate([
        serializr_1.serializable
    ], Comment.prototype, "createdAt", void 0);
    tslib_1.__decorate([
        serializr_1.serializable(serializr_1.object(CommentEntity))
    ], Comment.prototype, "comment", void 0);
    return Comment;
}());
exports.Comment = Comment;
//# sourceMappingURL=Comment.js.map